export default class ProductGroup {
  constructor(name, position, products) {
    this.name = name;
    this.position = position;
    this.products = products || [];
  }
}
